import { render, staticRenderFns } from "./ClientIndex.vue?vue&type=template&id=7ae65579&scoped=true"
import script from "./ClientIndex.vue?vue&type=script&lang=js"
export * from "./ClientIndex.vue?vue&type=script&lang=js"
import style0 from "./ClientIndex.vue?vue&type=style&index=0&id=7ae65579&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae65579",
  null
  
)

export default component.exports